import axios, { type AxiosError, type InternalAxiosRequestConfig, type AxiosResponse } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem('ams:accessToken');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Debug: log outgoing requests to help diagnose network/CORS issues
  try {
    // eslint-disable-next-line no-console
    console.debug('[api] request', { url: config.url, method: config.method, headers: config.headers });
  } catch (e) {
    // ignore
  }
  return config;
});

api.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    // Log full error object to help with 'Network Error' debugging in the browser
    try {
      // eslint-disable-next-line no-console
      console.error('[api] response error', {
        message: error.message,
        code: error.code,
        response: error.response && {
          status: error.response.status,
          headers: error.response.headers,
          data: error.response.data,
        },
        request: Boolean(error.request),
      });
    } catch (e) {
      // ignore
    }

    const status = error.response?.status;
    if (status === 401) {
      console.warn('API returned 401. Session payload:', error.response?.data);
      // localStorage.removeItem('ams:accessToken');
      // localStorage.removeItem('ams:user');
      // window.location.href = '/login';
      return Promise.reject(error);
    }
    return Promise.reject(error);
  },
);
